import { css } from "@emotion/react";

import {
    CheckCircleIcon,
    colors,
    InformationIcon
} from "@dotnet/telematics-design-system";

import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";

import { CompanyLevelBodyItemProps } from "../types/interfaces";

const CompanyLevelBodyItem = ({
    companyLevel,
    tooltipText,
    itemCSS
}: CompanyLevelBodyItemProps) => {
    const { green600 } = colors;

    return (
        <div css={css([itemCSS])}>
            {companyLevel === "SuccessIcon" ? (
                <CheckCircleIcon css={css({ color: green600 })} />
            ) : (
                <>
                    <span>{companyLevel}</span>

                    <div>
                        {tooltipText && (
                            <TooltipGeneral
                                placement={TOOLTIP_PLACEMENT.Top}
                                title={tooltipText}
                                css={css({
                                    whiteSpace: "pre-line"
                                })}
                            >
                                <div
                                    css={css({
                                        padding: "4px"
                                    })}
                                >
                                    <InformationIcon />
                                </div>
                            </TooltipGeneral>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default CompanyLevelBodyItem;
